export default "__VITE_ASSET__2d10a404__"